<div class="aca-mperm" [class.aca-mperm--embedded]="embedded">
  <p class="aca-mperm__note">
    <mat-icon>info_outline</mat-icon>
    {{ 'DMS.MENUPERM.NOTE' | translate }}
  </p>

  <div class="aca-mperm__body">
    <!-- the policy list: the locked system policy first, then the saved ones -->
    <div class="aca-mperm__side">
      <div class="aca-mperm__list">
        <button
          type="button"
          class="aca-mperm__row"
          *ngFor="let p of rows"
          [class.aca-mperm__row--on]="isEditing(p)"
          [class.aca-mperm__row--locked]="isBuiltin(p)"
          (click)="select(p)"
        >
          <span class="aca-mperm__rowicon"><mat-icon>{{ isBuiltin(p) ? 'verified_user' : 'rule' }}</mat-icon></span>
          <span class="aca-mperm__rowmain">
            <span class="aca-mperm__rowname">{{ isBuiltin(p) ? (p.name | translate) : p.name }}</span>
            <span class="aca-mperm__rowmeta">
              {{ 'DMS.MENUPERM.COUNTS' | translate: { users: p.users.length, groups: p.groups.length, menus: p.menus.length } }}
            </span>
          </span>
          <mat-icon class="aca-mperm__chevron" *ngIf="!isBuiltin(p)">chevron_right</mat-icon>
        </button>

        <p class="aca-mperm__empty" *ngIf="menuPerms.policies().length === 0">{{ 'DMS.MENUPERM.EMPTY' | translate }}</p>
      </div>

      <button mat-flat-button color="primary" class="aca-mperm__add" (click)="create()">
        <mat-icon>add</mat-icon>
        {{ 'DMS.MENUPERM.ADD' | translate }}
      </button>
    </div>

    <!-- the draft for the selected policy -->
    <form class="aca-mperm__editor" *ngIf="editing() as d" (ngSubmit)="save()">
      <div class="aca-mperm__edhead">
        <mat-icon>edit</mat-icon>
        <h3>{{ d.name || ('DMS.MENUPERM.NEW_NAME' | translate) }}</h3>
      </div>

      <mat-form-field appearance="outline">
        <mat-icon matPrefix>badge</mat-icon>
        <mat-label>{{ 'DMS.MENUPERM.NAME' | translate }}</mat-label>
        <input matInput [(ngModel)]="d.name" name="policyName" required maxlength="80" />
      </mat-form-field>

      <div class="aca-mperm__group">
        <div class="aca-mperm__ghead">
          <mat-icon>menu_open</mat-icon>
          <span>{{ 'DMS.MENUPERM.MENUS' | translate }}</span>
          <span class="aca-mperm__gheadtools">
            <button type="button" mat-button (click)="setAllMenus(navMenus, true)">{{ 'DMS.MENUPERM.SELECT_ALL' | translate }}</button>
            <button type="button" mat-button (click)="setAllMenus(navMenus, false)">{{ 'DMS.MENUPERM.CLEAR' | translate }}</button>
          </span>
        </div>
        <div class="aca-mperm__menus">
          <mat-checkbox *ngFor="let m of navMenus" [checked]="hasMenu(m.id)" (change)="toggleMenu(m.id, $event.checked)">
            {{ m.titleKey | translate }}
          </mat-checkbox>
        </div>

        <div class="aca-mperm__ghead aca-mperm__ghead--sub">
          <mat-icon>settings</mat-icon>
          <span>{{ 'DMS.MENUPERM.SETTINGS_MENUS' | translate }}</span>
          <span class="aca-mperm__gheadtools">
            <button type="button" mat-button (click)="setAllMenus(settingsMenus, true)">{{ 'DMS.MENUPERM.SELECT_ALL' | translate }}</button>
            <button type="button" mat-button (click)="setAllMenus(settingsMenus, false)">{{ 'DMS.MENUPERM.CLEAR' | translate }}</button>
          </span>
        </div>
        <div class="aca-mperm__menus">
          <mat-checkbox *ngFor="let m of settingsMenus" [checked]="hasMenu(m.id)" (change)="toggleMenu(m.id, $event.checked)">
            {{ m.titleKey | translate }}
          </mat-checkbox>
        </div>
      </div>

      <div class="aca-mperm__group">
        <div class="aca-mperm__ghead"><mat-icon>person_add</mat-icon><span>{{ 'DMS.MENUPERM.USERS' | translate }}</span></div>
        <div class="aca-mperm__chips" *ngIf="d.users.length">
          <span class="aca-mperm__chip" *ngFor="let u of d.users">
            <mat-icon>person</mat-icon>
            {{ label(u) }}
            <button type="button" class="aca-mperm__chipx" (click)="removeUser(u)" [attr.aria-label]="'Remove ' + label(u)">
              <mat-icon>close</mat-icon>
            </button>
          </span>
        </div>
        <mat-form-field appearance="outline">
          <mat-icon matPrefix>person_search</mat-icon>
          <mat-label>{{ 'DMS.MENUPERM.USER_SEARCH' | translate }}</mat-label>
          <input matInput [(ngModel)]="userTerm" name="userSearch" (ngModelChange)="searchUsers($event)" [matAutocomplete]="userAuto" />
          <mat-autocomplete #userAuto="matAutocomplete" (optionSelected)="addUser($event.option.value)">
            <mat-option *ngFor="let r of userResults()" [value]="r">{{ r.displayName }}</mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>

      <div class="aca-mperm__group">
        <div class="aca-mperm__ghead"><mat-icon>group_add</mat-icon><span>{{ 'DMS.MENUPERM.GROUPS' | translate }}</span></div>
        <div class="aca-mperm__chips" *ngIf="d.groups.length">
          <span class="aca-mperm__chip" *ngFor="let g of d.groups">
            <mat-icon>group</mat-icon>
            {{ label(g) }}
            <button type="button" class="aca-mperm__chipx" (click)="removeGroup(g)" [attr.aria-label]="'Remove ' + label(g)">
              <mat-icon>close</mat-icon>
            </button>
          </span>
        </div>
        <mat-form-field appearance="outline">
          <mat-icon matPrefix>group_search</mat-icon>
          <mat-label>{{ 'DMS.MENUPERM.GROUP_SEARCH' | translate }}</mat-label>
          <input matInput [(ngModel)]="groupTerm" name="groupSearch" (ngModelChange)="searchGroups($event)" [matAutocomplete]="groupAuto" />
          <mat-autocomplete #groupAuto="matAutocomplete" (optionSelected)="addGroup($event.option.value)">
            <mat-option *ngFor="let r of groupResults()" [value]="r">{{ r.displayName }}</mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>

      <p class="aca-mperm__hint" *ngIf="!isValid()"><mat-icon>error_outline</mat-icon>{{ 'DMS.MENUPERM.VALIDATION' | translate }}</p>

      <div class="aca-mperm__actions">
        <button mat-flat-button color="primary" type="submit" [disabled]="busy() || !isValid()">
          <mat-icon>save</mat-icon>
          {{ 'DMS.MENUPERM.SAVE' | translate }}
        </button>
        <button mat-button type="button" (click)="cancel()">{{ 'DMS.MENUPERM.CANCEL' | translate }}</button>
        <span class="aca-mperm__flex"></span>
        <button mat-button color="warn" type="button" *ngIf="isSaved(d)" (click)="remove()">
          <mat-icon>delete_outline</mat-icon>
          {{ 'DMS.MENUPERM.DELETE' | translate }}
        </button>
      </div>
    </form>

    <!-- nothing picked yet -->
    <div class="aca-mperm__placeholder" *ngIf="!editing()">
      <mat-icon>touch_app</mat-icon>
      <p>{{ 'DMS.MENUPERM.PICK_HINT' | translate }}</p>
    </div>
  </div>
</div>
